"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getObjectField = _interopRequireDefault(require("./getObjectField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Sorts an array of items by a specified nested field (using a string path).
 *
 * @param items - The array of items to sort.
 * @param path - The path string representing the nested field to use for sorting.
 * @param ascending - Whether to sort in ascending order (default is true).
 * @returns A new array of items sorted by the specified field.
 */
function sortArrayByPath(items, path) {
  let ascending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return [...(items || [])].sort((a, b) => {
    const valueA = (0, _getObjectField.default)(a, path);
    const valueB = (0, _getObjectField.default)(b, path);
    if (valueA === undefined || valueB === undefined) return 0;
    if (valueA < valueB) return ascending ? -1 : 1;
    if (valueA > valueB) return ascending ? 1 : -1;
    return 0;
  });
}
var _default = exports.default = sortArrayByPath;